export default {
  form: {
    header: {
      label: 'Header',
      placeholder: 'Header',
    },
    discount_badge: {
      label: 'Discount badge',
      placeholder: '10 EUR',
    },
    description: {
      label: 'Description',
      placeholder: 'Description',
    },
    qr_code_header: {
      label: 'UI box header',
      placeholder: 'UI box header',
    },
    qr_code_description: {
      label: 'UI box description',
      placeholder: 'UI box description',
    },
    footer: {
      label: 'Footer text',
      placeholder: 'Enter footer text',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Select URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Primary color',
    },
    background_color: {
      label: 'Background color',
    },
    cover_image: {
      label: 'Cover image',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Failed to load flyer',
  },
};
